
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Clock, ZapOff, Droplets, Flame } from 'lucide-react';

const PeakUsageCard: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4">
        {/* Energy Peak */}
        <Card className="bg-gradient-to-r from-green-50 to-green-100 dark:from-green-950 dark:to-green-900 border-green-200 dark:border-green-800">
          <CardContent className="p-4 flex items-center space-x-4">
            <div className="bg-green-100 dark:bg-green-800 p-2 rounded-full">
              <ZapOff className="h-6 w-6 text-green-600 dark:text-green-400" />
            </div>
            <div>
              <div className="text-sm font-medium text-green-800 dark:text-green-300">Energy Peak</div>
              <div className="text-2xl font-bold text-green-900 dark:text-green-200">450 kWh</div>
              <div className="text-xs text-green-700 dark:text-green-400 flex items-center mt-1">
                <Clock className="h-3 w-3 mr-1" /> 6:30 PM - 7:30 PM
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Gas Peak */}
        <Card className="bg-gradient-to-r from-red-50 to-red-100 dark:from-red-950 dark:to-red-900 border-red-200 dark:border-red-800">
          <CardContent className="p-4 flex items-center space-x-4">
            <div className="bg-red-100 dark:bg-red-800 p-2 rounded-full">
              <Flame className="h-6 w-6 text-red-600 dark:text-red-400" />
            </div>
            <div>
              <div className="text-sm font-medium text-red-800 dark:text-red-300">Gas Peak</div>
              <div className="text-2xl font-bold text-red-900 dark:text-red-200">85 m³</div>
              <div className="text-xs text-red-700 dark:text-red-400 flex items-center mt-1">
                <Clock className="h-3 w-3 mr-1" /> 7:00 PM - 8:00 PM
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Water Peak */}
        <Card className="bg-gradient-to-r from-blue-50 to-blue-100 dark:from-blue-950 dark:to-blue-900 border-blue-200 dark:border-blue-800">
          <CardContent className="p-4 flex items-center space-x-4">
            <div className="bg-blue-100 dark:bg-blue-800 p-2 rounded-full">
              <Droplets className="h-6 w-6 text-blue-600 dark:text-blue-400" />
            </div>
            <div>
              <div className="text-sm font-medium text-blue-800 dark:text-blue-300">Water Peak</div>
              <div className="text-2xl font-bold text-blue-900 dark:text-blue-200">78 m³</div>
              <div className="text-xs text-blue-700 dark:text-blue-400 flex items-center mt-1">
                <Clock className="h-3 w-3 mr-1" /> 8:00 AM - 9:00 AM
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PeakUsageCard;
